export const FORM_NAME = 'compatibilityForm'
